/**
 * @description 公共语言包
 */
export default {
  // 通用
  Common: {
    // 工作流
    Workflow: {
      state: "State",
      stateName: "State Name",
      stateOptions: {
        Complete: "Complete",
        Cancel: "Cancel",
        "NEW": "NEW",
        ToBeModified: "To Be Modified",
        InProgress: "In Progress",
        Issued: "Issued",
        Void: "Void",
      },
      StartDate: "Start Date",
    }
  }
}